import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssPropertiesToString } from "@utils";

export const ContainerStyled = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;

    ${theme.breakpoints.up("mobile")} {
      gap: 0.5rem;
    }

    ${theme.breakpoints.up("tablet")} {
      width: ${theme.breakpoints.values.tablet}px;
      gap: 1rem;
    }

    ${theme.breakpoints.up("desktop")} {
      width: ${theme.breakpoints.values.desktop}px;
      padding: 2.5rem 0;
    }

    ${theme.breakpoints.up("desktopXl")} {
      width: ${theme.breakpoints.values.desktopXl}px;
    }
  `,
);

export const CarouselStyled = styled("div")(
  ({ theme }) => css`
    padding: 0.4rem 0;
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-color: ${getColor(c => c.tokens.bg["soft-200"], theme)};
    width: 100%;
    overflow: hidden;
    color: ${getColor(c => c.tokens.text["strong-950"], theme)};

    ul {
      display: flex;
      gap: 5rem;
      padding-left: 5rem;
      margin: 0;
    }

    li {
      list-style: none;
    }

    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
      height: 40px;

      mask-image: linear-gradient(
        to right,
        transparent,
        transparent 00px,
        black 50px,
        black calc(100% - 50px),
        transparent calc(100%)
      );
    }

    ${theme.breakpoints.up("tablet")} {
      mask-image: linear-gradient(
        to right,
        transparent,
        transparent 40px,
        black 100px,
        black calc(100% - 100px),
        transparent calc(100% - 40px)
      );

      ${cssPropertiesToString(theme.typography.paragraph_large_medium)}
      height: 44px;
    }

    ${theme.breakpoints.up("desktop")} {
      mask-image: linear-gradient(
        to right,
        transparent,
        transparent 100px,
        black 220px,
        black calc(100% - 220px),
        transparent calc(100% - 100px)
      );

      ${cssPropertiesToString(theme.typography.paragraph_xlarge_medium)}
      height: 48px;
    }
  `,
);

export const HeaderStyled = styled("h2")(
  ({ theme }) => css`
    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
    }

    ${theme.breakpoints.up("tablet")} {
      ${cssPropertiesToString(theme.typography.paragraph_large_medium)}
    }

    ${theme.breakpoints.up("desktop")} {
      ${cssPropertiesToString(theme.typography.paragraph_xlarge_medium)}
    }

    color: ${getColor(c => c.tokens.text["sub-600"], theme)};
  `,
);

export const StaticTechListStyled = styled("ul")(
  () => css`
    display: flex;
    flex-wrap: nowrap;
    overflow-x: hidden;
    padding: 0;
    margin: 0;
    white-space: nowrap;
  `,
);

export const StaticTechItemStyled = styled("li")(
  () => css`
    display: inline-block;
    margin: 0 0px;
    list-style: none;
  `,
);

export const MarqueeItemStyled = styled("div")(
  () => css`
    margin: 0 32px;
  `,
);
